import React, { useState, useEffect } from 'react';
import './Ekibimiz.css'; 

// Firebase importları
import { collection, addDoc, doc, updateDoc, deleteDoc, onSnapshot } from 'firebase/firestore';
// Storage fonksiyonlarını ekledik
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { db, storage } from '../firebase/firebase-config'; // storage'ı import ettiğinden emin ol

const Ekibimiz = () => {
  const [team, setTeam] = useState([]);
  const [loading, setLoading] = useState(true);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editId, setEditId] = useState(null);
  
  // Form verileri
  const [formData, setFormData] = useState({ 
    name: '', 
    position: '', 
    image: '' // Bu artık veritabanındaki URL'i tutacak
  });

  // Yüklenecek dosya state'i
  const [imageFile, setImageFile] = useState(null);
  const [uploading, setUploading] = useState(false); // Yükleniyor butonu için

  // 1. Firebase'den Verileri Çek
  useEffect(() => {
    const teamCollectionRef = collection(db, "team");
    const unsubscribe = onSnapshot(teamCollectionRef, (snapshot) => {
      const teamData = snapshot.docs.map(doc => ({
        ...doc.data(),
        id: doc.id
      }));
      setTeam(teamData);
      setLoading(false);
    });
    return () => unsubscribe();
  }, []);

  // Modal Açma
  const openModal = (member = null) => {
    setImageFile(null); // Dosya seçimini sıfırla
    if (member) {
      setEditId(member.id);
      setFormData({ name: member.name, position: member.position, image: member.image });
    } else {
      setEditId(null);
      setFormData({ name: '', position: '', image: '' });
    }
    setIsModalOpen(true);
  };

  // 2. KAYDETME (Resim Yükleme Dahil)
  const handleSave = async (e) => {
    e.preventDefault();
    setUploading(true); // Butonu disable et
    
    try {
      let imageUrlToSave = formData.image; // Varsayılan olarak eski resim kalsın

      // Eğer yeni bir dosya seçildiyse STORAGE'a yükle
      if (imageFile) {
        // Dosya yolu: team_images/zaman_dosyaAdi
        const imageRef = ref(storage, `team_images/${Date.now()}_${imageFile.name}`);
        
        // Yükleme işlemi
        await uploadBytes(imageRef, imageFile);
        
        // Yüklenen dosyanın URL'ini al
        imageUrlToSave = await getDownloadURL(imageRef);
      }

      // Firestore'a kaydet (URL ile birlikte)
      const dataToSave = {
        name: formData.name,
        position: formData.position,
        image: imageUrlToSave
      };

      if (editId) {
        // GÜNCELLEME
        const memberDoc = doc(db, "team", editId);
        await updateDoc(memberDoc, dataToSave);
        alert("Ekip üyesi ve görsel güncellendi!");
      } else {
        // YENİ EKLEME
        const teamCollectionRef = collection(db, "team");
        await addDoc(teamCollectionRef, dataToSave);
        alert("Yeni üye başarıyla eklendi!");
      }
      setIsModalOpen(false);
    } catch (error) {
      console.error("Hata oluştu:", error);
      alert("Bir hata oluştu: " + error.message);
    } finally {
      setUploading(false); // Yükleme bitti
    }
  };

  // SİLME
  const handleDelete = async (id) => {
    if (window.confirm("Bu ekip üyesini silmek istediğinize emin misiniz?")) {
      try {
        const memberDoc = doc(db, "team", id);
        await deleteDoc(memberDoc);
        // İpucu: Burada aslında Storage'dan resmi de silmek lazım ama şimdilik veriyi silmek yeterli.
      } catch (error) {
        console.error("Silme hatası:", error);
        alert("Silinirken bir hata oluştu.");
      }
    }
  };

  return (
    <div className="team-container">
      <div className="page-header">
        <h2>Ekibimiz</h2>
        <button className="add-btn" onClick={() => openModal()}>
          + Yeni Üye Ekle
        </button>
      </div>

      <div className="table-container">
        <table className="team-table">
          <thead>
            <tr>
              <th style={{ width: '150px' }}>Görsel</th>
              <th>Ad Soyad</th>
              <th>Ünvan / Görev</th>
              <th style={{ width: '150px', textAlign: 'right' }}>İşlemler</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan="4" style={{textAlign: 'center', padding: '20px'}}>Yükleniyor...</td></tr>
            ) : (
              <>
                {team.map((member) => (
                  <tr key={member.id}>
                    <td>
                      {member.image ? (
                        <img src={member.image} alt={member.name} style={{ width: '60px', height: '60px', objectFit: 'cover', borderRadius: '8px' }} />
                      ) : (
                        <div className="no-image-box">Resim Yok</div>
                      )}
                    </td>
                    <td>{member.name}</td>
                    <td>{member.position}</td>
                    <td className="action-buttons-cell">
                      <div className="buttons-wrapper">
                        <button className="action-btn edit-btn" onClick={() => openModal(member)}>Düzenle</button>
                        <button className="action-btn delete-btn" onClick={() => handleDelete(member.id)}>Sil</button>
                      </div>
                    </td>
                  </tr>
                ))}
              </>
            )}
          </tbody>
        </table>
      </div>

      {/* MODAL */}
      {isModalOpen && (
        <div className="modal-overlay">
          <div className="modal-content">
            <div className="modal-header">
              <h3>{editId ? 'Üye Düzenle' : 'Yeni Üye Ekle'}</h3>
              <button className="close-btn" onClick={() => setIsModalOpen(false)}>&times;</button>
            </div>
            <form onSubmit={handleSave}>
              <div className="form-group">
                <label>Ad Soyad</label>
                <input 
                  type="text" 
                  required 
                  value={formData.name} 
                  onChange={(e) => setFormData({...formData, name: e.target.value})} 
                />
              </div>
              <div className="form-group">
                <label>Ünvan / Görev</label>
                <input 
                  type="text" 
                  required 
                  placeholder="Örn: Kurucu Avukat"
                  value={formData.position} 
                  onChange={(e) => setFormData({...formData, position: e.target.value})} 
                />
              </div>

              {/* GÖRSEL YÜKLEME ALANI */}
              <div className="form-group">
                <label>Profil Fotoğrafı</label>
                
                {/* Mevcut resim önizlemesi (Varsa) */}
                {formData.image && !imageFile && (
                  <div style={{marginBottom: '10px'}}>
                    <img src={formData.image} alt="Mevcut" style={{width: '80px', height: '80px', objectFit: 'cover', borderRadius: '8px'}} />
                    <p style={{fontSize: '12px', color: '#666'}}>Mevcut Görsel</p>
                  </div>
                )}

                <input 
                  type="file" 
                  accept="image/*" // Sadece resim dosyaları
                  onChange={(e) => {
                    if (e.target.files[0]) {
                      setImageFile(e.target.files[0]);
                    }
                  }} 
                />
                <small style={{color: '#888', fontSize: '11px', display: 'block', marginTop: '5px'}}>
                  {editId ? "Yeni resim seçerseniz eskisi değişecektir." : "Lütfen bir fotoğraf seçiniz."}
                </small>
              </div>

              <div className="modal-footer">
                <button type="button" className="cancel-btn" onClick={() => setIsModalOpen(false)}>İptal</button>
                <button 
                  type="submit" 
                  className="save-btn" 
                  disabled={uploading} // Yüklenirken tıklanmasın
                  style={{ opacity: uploading ? 0.7 : 1, cursor: uploading ? 'not-allowed' : 'pointer' }}
                >
                  {uploading ? 'Yükleniyor...' : 'Kaydet'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default Ekibimiz;